import React from 'react'
import { Redirect, Route } from 'react-router-dom'

// The organizations sub-pages (the list and "add login to organization")
// were replaced by the connection workspace's Domains & organizations
// section, where linking, unlinking and rules now happen in place. Old links
// and bookmarks land there. The old pages' files stay: other pages import
// the rule modal and its label.
//
// The legacy role mapping pages (a bare grid with one-click delete, and its
// add form) are retired the same way (audit F4): the workspace's Claims &
// mapping section adds and, now, deletes mappings with a confirmation.
export const ProviderOrganizationRedirect = () =>
  <>
    <Route
      exact
      path={['/admin/sso/connections/:providerID/organization', '/admin/sso/connections/:providerID/organization/add']}
      render={({ match }) => <Redirect to={`/admin/sso/connections/${match.params.providerID}#routing`} />}
    />
    <Route
      exact
      path={['/admin/sso/connections/:providerID/mapping', '/admin/sso/connections/:providerID/mapping/add']}
      render={({ match }) => <Redirect to={`/admin/sso/connections/${match.params.providerID}#claims`} />}
    />
  </>
